import Joi from "joi-browser";

function requiredErrorsAsString(errors) {
    return {
        template: " {{message}}",
        context: {
            errors: errors.length,
            message: "is required",
        },
    };
}

const CreateAndEditMaterialSchema = Joi.object().keys({
    name: Joi.string()
        .trim()
        .required()
        .label("Name")
        .error((errors) => {
            return requiredErrorsAsString(errors);
        }),
    technicalName: Joi.string()
        .regex(/^([a-zA-Z0-9-_']+\s)*[a-zA-Z0-9-_']+$/)
        .trim()
        .max(125)
        .min(2)
        .allow("")
        .allow(null)
        .optional()
        .label("Technical Name")
        .error((errors) => {
            function errorsAsString() {
                let err = errors[0];
                if (err.type === "string.regex.base") {
                    return "should only contain letters, numbers, hyphens, single qoutes, underscores or spaces.";
                }
                if (err.type === "string.min") {
                    return "length must be at least 2 characters long.";
                }
                if (err.type === "string.max") {
                    return "length must be less than or equal to 20 characters long";
                } else return;
            }
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(),
                },
            };
        }),
    materialGroupId: Joi.string()
        .required()
        .label("Group")
        .error((errors) => {
            return requiredErrorsAsString(errors);
        }),
});

export default { CreateAndEditMaterialSchema };
